export default __webpack_public_path__ + "static/media/gallery 7.ce1034d0.png";